<template>
  <div class="Login">
<!--    <mu-tabs :value.sync="active"-->
<!--             class="tab"-->
<!--             inverse-->
<!--             color="#3B9CFD"-->
<!--             indicator-color="#3B9CFD"-->
<!--             center>-->
<!--      <mu-tab>登录</mu-tab>-->
<!--    </mu-tabs>-->

    <div class="main">
      <mu-form :model="form"
               ref="form"
               class="mu-demo-form"
               :label-position="'top'"
               label-width="80">

        <mu-form-item prop="phoneNo" label="手机号" label-float icon="phone_iphone" :error-text="verify_error" :rules="rule.phoneNoRules">
          <mu-text-field v-model="form.phoneNo" @keyup.enter.native="( load || isAgree.length == 0 ? '': onSubmit(form) )"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="code" label="验证码" label-float icon="verified_user" :rules="rule.codeRules">
          <mu-text-field v-model="form.code" @keyup.enter.native="( load || isAgree.length == 0  ? '': onSubmit(form) )" >
            <template #append>
              <mu-button v-if="!is_verify"
                         color="primary"
                         small
                         round
                         @click="get_verify(form.phoneNo)">获取验证码</mu-button>
              <van-count-down
                  v-show="is_verify"
                  ref="countDown"
                  :time="60000"
                  :auto-start="false"
                  format="ss"
                  @finish="finish"
              />
            </template>
          </mu-text-field>
        </mu-form-item>

        <div class="Agreement">
          <Agreement :isAgree.sync="isAgree" :agreementType="agreementType"
                     :agreementIdList.sync="form.agreementIdList" ></Agreement>
        </div>

        <mu-form-item>
          <div class="form_but">
            <mu-button :disabled="isAgree.length == 0" style="width: 100%; height: 3.25rem;margin-top: 3.125rem;" round color="primary" v-loading="load"
                       data-mu-loading-size="24" @click.native="( load || isAgree.length == 0 ? '' : onSubmit(form) )">登录</mu-button>
          </div>
        </mu-form-item>
      </mu-form>


    </div>


  </div>
</template>

<script>
import Agreement from "@/components/Agreement";
export default {
  name: "Login",
  data() {
    return{
      isAgree: [],
      active: 0,
      // 表单
      form: {
        phoneNo: null,
        code: null,
        weChatUser: this.$store.state.openId,
        agreementIdList: []
      },
      // 表单验证
      rule: {
        phoneNoRules: [
          { validate: (val) => !!val, message: '请输入登录手机号'},
          { validate: (val) => /^((13[0-9])|(14[0,1,4-9])|(15[0-3,5-9])|(16[2,5,6,7])|(17[0-8])|(18[0-9])|(19[0-3,5-9]))\d{8}$/.test(val), message: '登录手机号不正确'},
        ],
        codeRules: [
          { validate: (val) => !!val, message: '请输入验证码'},
          { validate: (val) => val.length == 6, message: "验证码长度应为 6 位"}
        ],
      },
      // 验证码倒计时
      is_verify: false,
      // 按钮加载
      load: false,
      // 获取验证码验证手机号
      verify_error: null,
      // 微信授权地址
      url: null,
      // 用户协议Type
      agreementType: "login"
    }
  },
  created() {

    if(this.$route.query.code != this.$store.state.code ) {
      this.wxCode(this.$route.query.code);
    }
    // else {
    //   this.get_auth();
    // }

  },
  mounted() {
    this.$progress.done();
  },
  methods: {
    // get_auth() {
    //   this.url= "https://open.weixin.qq.com/connect/oauth2/authorize?" +
    //       "appid="+ process.env.VUE_APP_AppID +
    //       "&redirect_uri=" + process.env.VUE_APP_WxUrl + "/Login" +
    //       "&response_type=code" +
    //       "&scope=snsapi_userinfo" +
    //       "&state=STATE#wechat_redirect"
    //   // window.location.href= this.url;
    //   window.location.replace(this.url);
    // },
    wxCode(e) {
      this.$get("wx/userAuth",{code : e})
        .then(res => {
          console.log(res);

          if(res.data.sameCode) {
            // this.get_auth();
          }else {
            this.$store.commit("setOpenId",res.data.weChatUser);
            this.form.weChatUser= res.data.weChatUser;
            this.$store.commit("setCode",e);
          }

        })
    },
    get_verify(e) {
      if(/^((13[0-9])|(14[0,1,4-9])|(15[0-3,5-9])|(16[2,5,6,7])|(17[0-8])|(18[0-9])|(19[0-3,5-9]))\d{8}$/.test(e)) {
        let obj= {}
        obj["phoneNo"]= e;

        this.$post("login/sendPhoneCode",obj)
          .then(res=> {

            if(res) {
              this.is_verify= true;
              this.$refs.countDown.start();
            }

          })

      }else {
        this.verify_error= "请输入正确手机号"
      }

    },
    finish() {
      this.is_verify= false;
      this.$refs.countDown.reset();
    },
    onSubmit(formName) {

      this.$refs.form.validate()
          .then((res) => {
            if(res) {
              this.load= true;
              this.$post("login",formName)
                .then(res => {
                  this.load= false;
                  if(res) {

                    this.$store.commit("setCode",null);
                    this.$store.commit("setOpenId",null);
                    this.$store.commit("setUserId",res.data);

                    if(!this.isPc()) {
                      this.$router.go(-1);
                    }else {
                      this.$router.go(-2);
                    }



                    // window.history.go(-1) // 是返回上一页

                    // this.$router.replace({
                    //   path: this.$store.state.Routers
                    // })

                    // if(this.$store.state.Routers.router) {
                    //
                    //   this.$router.replace({
                    //     path: this.$store.state.Routers.router,
                    //     query: {
                    //       id: this.$store.state.Routers.id,
                    //       fromUserId: this.$store.state.Routers.fromUserId,
                    //     }
                    //   })
                    //
                    // }else {
                    //   this.$router.replace({
                    //     path: "/index"
                    //   })
                    // }

                  }
                })
            }
          });
    },
    isPc() {
      var userAgentInfo = navigator.userAgent;
      var Agents = ["Android", "iPhone",
        "SymbianOS", "Windows Phone",
        "iPad", "iPod"];
      var flag = true;
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    }
  },
  components: {
    Agreement
  }
}
</script>

<style lang="less" scoped>
    @import "../style/Login";
</style>
